import React from 'react';
import CommonDate from '../CommonDate';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

export enum EType {
  YES = 'YES',
  NO = 'NO',
}

const RegisteredSpecificTime = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const options = [
    { value: EType.YES, label: getI18n('general.status.registered') },
    { value: EType.NO, label: getI18n('general.status.notRegistered') },
  ];

  const {
    noStyle,
    selectName,
    daysName,
    policyName,
    singleDayName,
    dayRangeName,
    disabled,
  } = props;
  return (
    <CommonDate
      disabled={disabled}
      hasAnytime
      noStyle={noStyle}
      options={options}
      selectName={selectName}
      daysName={daysName}
      policyName={policyName}
      singleDayName={singleDayName}
      dayRangeName={dayRangeName}
      triggerSelectValue={[EType.YES]}
      selectPlaceholder={getI18n(
        'general.registeredSpecificTime.pleaseselectregisterstatus',
      )}
    />
  );
};
export default RegisteredSpecificTime;
